$(function () {
  const animation_widget = {
    init() {
      this.create();
    },
    create() {
      const elements = $("[data-timer]").toArray();
      if (elements.length === 0) return;

      elements.sort((a, b) => $(a).offset().top - $(b).offset().top);

      const animateSequentially = (index) => {
        if (index >= elements.length) return;

        const $ele = $(elements[index]);
        const time = $ele.data('timer');
        const breakpoint = $ele.data('breakpoint');

        if ($(window).width() > parseInt(breakpoint)) {
          $ele.addClass("opened");
          
          setTimeout(() => {
            $ele.removeClass("opened");
            setTimeout(() => animateSequentially(index + 1), 100);
          }, time);
        } else {
          animateSequentially(index + 1);
        }
      };

      animateSequentially(0);
    },
  };

  animation_widget.init();
});